import React, { Fragment } from 'react';
import { calculateColor, defaultZero } from '../utils/helpers';
import { InlineProgressBar } from './InlineProgressBar';
import { SpaceBetweenDiv } from './design-system/containers';
import { palette } from './design-system/colors';
import styled from 'styled-components';
import { rgba } from 'polished';

const Text = styled.span`
    font-size: ${(props) => props.fontSize}px;
    font-weight: 700;
    color: ${(props) => props.color};
`;

// to use this component, specify:
// - value

// hidePercentage
// - percentage is shown by default, if you want to hide it, use hidePercentage

// fullWidth
// - use fullWidth prop if the progress bar should take all available width of the parent

// fontSize
// - it's 14px by default
// - if custom fontSize needed, specify it as fontSize={24}

// showNA
// - display N/A instead of the number, in grey

// invertColoring
// - if true, show red color for highest numbers & green color for lowest numbers
// - ie, if showing % of employees at risk, the higher the number, the worse it gets, so it needs to be red

// ...props
// specify all other props that are usable in InlineProgressBar

export function ProgressWithNumber({
    value,
    hidePercentage,
    fontSize = 14,
    fullWidth,
    showNA,
    invertColoring = false,
    ...props
}) {
    const content = (
        <Fragment>
            <InlineProgressBar
                value={showNA ? 100 : defaultZero(value)}
                customColor={
                    showNA
                        ? '#EBEEF1'
                        : calculateColor(invertColoring ? 100 - value : value)
                }
                {...props}
                fullWidth={fullWidth}
            />
            <Text
                color={
                    showNA
                        ? rgba(palette.graphite.heavyMetal, 0.6)
                        : calculateColor(invertColoring ? 100 - value : value)
                }
                fontSize={fontSize}
            >
                {showNA ? 'N/A' : defaultZero(value)}
                {hidePercentage || showNA ? '' : '%'}
            </Text>
        </Fragment>
    );

    return fullWidth ? (
        <SpaceBetweenDiv alignCenter $noWrap>
            {content}
        </SpaceBetweenDiv>
    ) : (
        content
    );
}
